import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { JoinScreen } from './components/JoinScreen';
import { PaymentScreen } from './components/PaymentScreen';
import { RedirectScreen } from './components/RedirectScreen';
import { AppLinkRedirect } from './components/AppLinkRedirect';
import { InvitationLanding } from './components/invitation/InvitationLanding';
import { SplitReceiptPage } from './splitReceipt/SplitReceiptPage';
import { SplitSessionPage } from './splitSession/SplitSessionPage';

function App() {
  return (
    <Router>
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif'
      }}>
        <Routes>
          {/* Payment-link landing: https://…/?token=<payment-uuid> */}
          <Route path="/" element={<JoinScreen />} />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="/r/:token" element={<RedirectScreen />} />
          {/* In-app route links when the app didn't open: /go/loyalty/<restaurantId> */}
          <Route path="/go/*" element={<AppLinkRedirect />} />
          {/* Invitation landing: https://join.pebla.app/i/<opaque-token> */}
          <Route path="/i/:token" element={<InvitationLanding />} />
          {/* Receipt split shared from the app: /split-receipt?splitReceipt=1&v=2&data=… */}
          <Route path="/split-receipt" element={<SplitReceiptPage />} />
          {/* Receipt split kept on the server: https://app.pebla.io/s/<share-token> */}
          <Route path="/s/:token" element={<SplitSessionPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;